import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  prize: null,
  piece: null,
};

export const prizeManagementSlice = createSlice({
  name: 'prizeManagement',
  initialState,
  reducers: {
    setPrize: (state, action) => {
      state.prize = action.payload;
    },

    setPiece: (state, action) => {
      state.piece = action.payload;
    },
  },
});

export const { setPrize, setPiece } = prizeManagementSlice.actions;
export const selectPrizeManagement = (state) => state.prizeManagement;

export default prizeManagementSlice.reducer;
